const genNum = (install) =>
  install ? install.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;

export default genNum;
